<template>
  <div class="sleep-result__item" v-if="isSelected">
    <div class="b-card b-card_main">
      <div class="b-card__content block-products">
        <div class="b-card__top">
          <div class="product-card-action-container">
            <a href="javascript:void(0)" class="product-card-action"
              >-25% на комплект для сна</a
            >
          </div>
          <a :href="getProductUrl" target="_blank" class="b-card__image">
            <span class="b-card__image-picture">
              <img
                class="js-view-image lazyloaded"
                :alt="getSelectedProduct.NAME"
                :title="getSelectedProduct.NAME"
                :data-src="getSelectedProduct.PREVIEW_PICTURE"
                :src="getSelectedProduct.PREVIEW_PICTURE"
              />
            </span>
          </a>
        </div>
        <div class="b-card__center">
          <div class="b-card__price">
            <div class="g-price">
              {{ getPrice }} <span class="g-price__rub">₽</span>
            </div>
          </div>
          <a :href="getProductUrl" target="_blank" class="b-card__name">
            {{ getSelectedProduct.NAME }}
          </a>
          <div class="b-card-size-wrapper">
            Размер:
            <span class="b-card-size"> {{ this.getSelectedOffer.SIZE }}</span>
          </div>
        </div>
      </div>

      <div class="sleep-button absolute d-flex d-flex_column d-flex_center">
        <a
          @click="changeSelect"
          class="button button_primary button_sm w-100 text-uppercase fs-14 fw-medium js-scroll-link"
        >
          изменить <span class="d-md-none">выбор</span>
        </a>
      </div>
    </div>
  </div>

  <div class="sleep-result__item" v-if="!isSelected">
    <div
      class="sleep-result__card h-100 bg-white d-flex d-flex_center d-flex_column"
    >
      <div class="sleep-result__question fw-medium text-center">?</div>
      <a
        @click="changeSelect"
        class="button button_primary button_sm w-100 text-uppercase fs-14 fw-medium mt-16 js-scroll-link"
      >
        выбрать&nbsp;<span class="d-md-none">товар</span>
      </a>
    </div>
  </div>
</template>

<script>
import { useBundleStore } from "@/sleep_bundle/stores/bundle";

export default {
  name: "SelectedProduct",
  setup() {
    const store = useBundleStore();

    return {
      store,
    };
  },
  props: {
    number: Number,
  },
  methods: {
    changeSelect() {
      this.store.selected["offer" + this.number] = {};
      document
        .getElementById("pool" + this.number)
        .scrollIntoView({ block: "center" });
    },
  },
  computed: {
    isSelected() {
      return Object.keys(this.getSelectedOffer).length > 0;
    },
    getSelectedOffer() {
      return this.store.selected["offer" + this.number];
    },
    getSelectedProduct() {
      const product = Object.values(this.store.product).filter((product) => {
        return product.ID === this.getSelectedOffer.PRODUCT_ID;
      });

      return product[0];
    },
    getProductUrl() {
      return "/product/" + this.getSelectedProduct.CODE + "/";
    },
    getPrice() {
      const availabilityItem = Object.values(this.store.availability).filter(
        (record) => {
          return record.UF_SKU_ID === this.getSelectedOffer.ID;
        }
      );

      return availabilityItem[0]["UF_PRICE_CURRENT"];
    },
  },
};
</script>
